<script setup>
import { ref, onMounted, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useConfirm } from "primevue/useconfirm"
import { FilterMatchMode } from 'primevue/api'
import { useRouter } from 'vue-router'
import axios from 'axios'

import Company from './sub_components/Gartenkultur-Company.vue'

/////////////////////
// Interface Props //
/////////////////////
const loader = ref(false)
const toast = useToast()
const confirm = useConfirm()
const router = useRouter()

// filters
const filter_contacts = ref({'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                            'types': {value: null, matchMode: FilterMatchMode.CONTAINS}})

// data
const companies = ref([])
const contact = ref(null)
const company_id = ref(null)
const company_slider = ref(false)
const company_slider_position = 'right'
const types = ref([])
const pipeline = ref("stRmVwTD")
const stages = ref([])
const users = ref([])

onMounted( async () => {
    get_users()
    get_companies()
    get_stages()
    get_company_types()
})

const get_users = () => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/get-users')
    .then(response => {
        console.log("users", response.data)
        users.value = response.data
        loader.value = false
    })
}

const get_companies = () => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + "/gartenkultur/crm/get-companies")
    .then (response => {
        console.log("companies", response.data)
        companies.value = response.data
        loader.value = false
    })
}

const get_company_types = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-company-types')
    .then(response => {
        types.value = response.data
        console.log("types", response.data)
    })
}


const get_stages = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-stages?pipeline=' + pipeline.value)
    .then(response => {
        stages.value = response.data
        console.log("stages", response.data)
    })
}

const new_deal = () => {
    console.log('new deal')
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/create-contact-deal', contact.value)
    .then(response => {
        console.log(response.data)
        toast.add({severity:'success', summary:'Vertriebsprozess gestartet', life: 3000})
        get_contacts()
    })
}

const company_details = (event) => {
    company_id.value = event.data.id
    company_slider.value = true
}

const filter_type = (type) => {
    filter_contacts.value.types.value = [type]
    console.log(filter_contacts.value)
}

const open_url = (url) => {
    window.open(url, '_blank')
}

const selected_type = ref("Alle Firmen")
const expanded_companies = ref([])

const search_update = () => {
    if(filter_contacts.value['global'].value.length > 0){
        expanded_companies.value = companies.value.reduce((com, p) => (com[p.id] = true) && com, {})
        filter_contacts.value['types'].value = []
    }
    else{
        expanded_companies.value = null
    }
}

const company = ref({
    name: null,
    types: []
})
const create_company_dialog = ref(false)
const new_company = () => {
    create_company_dialog.value = true
}

const save_company = () => {
    loader.value = true
    console.log(company.value)
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/create-company', company.value)
    .then(response => {
        console.log(response.data)
        toast.add({severity:'success', summary:'Firma gespeichert', life: 3000})
        create_company_dialog.value = false
        get_companies()
        filter_contacts.value['types'].value = []
        filter_contacts.value['global'].value = company.value.name
        loader.value = false
    })
}

</script>
<style lang="scss" scoped>
    @import '@/core/assets/primevue/primeflex.scss';
</style>
<template>
    <ProgressSpinner v-if="loader" style="width:50px;height:50px" strokeWidth="8" animationDuration="1.5s" aria-label="Custom ProgressSpinner" class="spinner" />
    <Toast />
    <ConfirmDialog />
    <Toolbar>
        <template #start>
            <Button  v-for="type in types" :key="type" :class="selected_type == type.name ? 'bg-primary' : ''" rounded :label="type.name" class="mr-2 bg-black-alpha-90 border-black-alpha-70 hover:border-primary hover:bg-primary" @click="filter_type(type.name), selected_type = type.name" :badge="String(type.total)" badgeSeverity="contrast" />
        </template>
        <template #end>
            <Button label="Export" icon="pi pi-file-excel" v-tooltip.top="'Exportieren'" class="mr-2" />
        </template>
    </Toolbar>
    <Toolbar class="mt-2">
        <template #start>
            <span class="p-input-icon-left mr-3">
                <i class="pi pi-search" />
                <InputText v-model="filter_contacts['global'].value" placeholder="Suche" class="w-full" @update:modelValue="search_update()" />
            </span>
        </template>
        <template #end>
            <Button label="Neue Kunden/Prospect" icon="pi pi-plus" @click="new_company()" class="w-auto mr-2" v-tooltip.bottom="'Neue Kunde/Prospect erfassen'" />
        </template>
    </Toolbar>
    <div rounded class="overflow-hidden shadow-3 border-200 mt-4">
        <DataTable v-model:filters="filter_contacts" v-model:expandedRows="expanded_companies" dataKey="id" @row-click="company_details" :value="companies" :rows="200" responsiveLayout="scroll" :rowHover="true" :rowsPerPageOptions="[200,500,1000]" :paginator="true" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="{first} to {last} from {totalRecords}">
            <Column field="name" header="Name">
                <template #body="slotProps">
                    <Avatar icon="pi pi-building" shape="circle" class="mr-2 bg-primary text-white" />
                    <span class="font-bold mr-2">{{slotProps.data.name}}</span>
                    <i v-if="slotProps.data.email" class="pi pi-envelope mr-2 pointer-cursor text-primary" />
                    <i v-if="slotProps.data.phone" class="pi pi-phone mr-2 pointer-cursor text-primary" />
                </template>
            </Column>
            <Column field="types" header="Typ" sortable>
                <template #body="slotProps">
                    <template v-for="type in slotProps.data.types" :key="type">
                        <Chip v-if="type == 'Kunde'" class="mr-2 mb-1 bg-blue-700 text-white" label="Kunde" />
                        <Chip v-if="type == 'Prospect'" class="mr-2 mb-1 bg-red-700 text-white" label="Prospect" />
                    </template>
                </template>
            </Column>
            <Column field="contacts" header="Kontakte" sortable>
                <template #body="slotProps">
                    <Chip icon="pi pi-user" class="mr-2 mb-1" :label="String(slotProps.data.contacts.length)" v-tooltip.top="'Anzahl verknüpfte Kontakte'" />
                </template>
            </Column>
            <Column field="stage" header="Vetrieb" sortable>
                <template #body="slotProps">
                    <Chip v-if="slotProps.data.stage" icon="pi pi-folder" :label="slotProps.data.stage" class="mr-2 bg-green-200 text-black-alpha-90" />
                </template>
            </Column>
            <Column field="phone" header="Telefon" hidden />
            <Column field="email" header="E-Mail" hidden />
            <Column field="contact_meta" header="Personen Meta" hidden />
            <template #expansion="slotProps">
                <div v-if="slotProps.data.contacts.length > 0" rounded class="overflow-hidden shadow-3 border-200 mt-1">
                    <DataTable :value="slotProps.data.contacts">
                        <Column field="name" header="Name">
                            <template #body="slotProps">
                                <div class="flex align-items-center">
                                    <Avatar icon="pi pi-user" shape="circle" class="mr-2 bg-primary text-white" />
                                    <span class="font-bold mr-2">{{slotProps.data.first_name}}</span>
                                    <span class="font-bold mr-2">{{slotProps.data.last_name}}</span>
                                </div>
                            </template>
                        </Column>
                        <Column field="email" header="E-Mail">
                            <template #body="slotProps">
                                <div class="flex align-items-center">
                                    <span class="mr-2">{{slotProps.data.email}}</span>
                                    <i v-if="slotProps.data.email" class="pi pi-envelope mr-2 pointer-cursor text-primary" @click="open_url('mailto:'+slotProps.data.email)" />
                                </div>
                            </template>
                        </Column>
                        <Column field="phone" header="Telefon">
                            <template #body="slotProps">
                                <div class="flex align-items-center">
                                    <span class="mr-2">{{slotProps.data.phone}}</span>
                                    <i v-if="slotProps.data.phone" class="pi pi-phone mr-2 pointer-cursor text-primary" @click="open_url('tel:'+slotProps.data.phone)" />
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </template>
        </DataTable>
    </div>

    <Sidebar v-model:visible.sync="company_slider" :position="company_slider_position" style="width: 50%">
            <Company v-if="company_id" :company_id="company_id" />
    </Sidebar>

    <Dialog v-model:visible="create_company_dialog" :style="{width: '70%'}" header="Neue Kunde / Prospect" :modal="true" class="p-fluid z-5">
        <div class="grid">
            <div class="col-6 mt-5">
                <span class="p-float-label">
                    <InputText id="company_name" v-model="company.name" />
                    <label for="company_name">Kunde / Prospect</label>
                </span>
            </div>
            <div class="col-6 mt-5">
                <span class="p-float-label">
                    <MultiSelect id="company_type" v-model="company.types" :options="types" optionLabel="name" optionValue="value" class="w-full" />
                    <label for="company_type">Typ</label>
                </span>
            </div>
            <div class="col-12 mt-3">
                <Button label="Speichern" icon="pi pi-check" @click="save_company()" class="bg-green-700 text-white border-green-600 w-auto mr-2" />
                <Button label="Abbrechen" icon="pi pi-times" @click="create_company_dialog = false" class="bg-red-700 text-white border-red-600 w-auto" />
            </div>
        </div>
    </Dialog>
</template>